import React from 'react'
import ProtectByAccessToken from '../components/Security/ProtectByAccessToken'
import UniquePassAuthContainer from '../containers/UniquePassAuth/UniquePassAuth.container'

/**
 * The UniquePassAuth's page.
 */
const UniquePassAuth = () => {
  return (
    <ProtectByAccessToken>
      <UniquePassAuthContainer />
    </ProtectByAccessToken>
  )
}

export default UniquePassAuth
